// Parse a user-supplied distance string into a numeric value (in feet for ft mode, raw number otherwise).
// Accepts forms like: 10.5, 10'7, 10' 7", 10ft 7in, 10 7, 10-7
export const parseDistanceInput = (input, unit) => {
  if (!input) return NaN;
  const value = String(input).toLowerCase().trim();

  if (unit === 'ft') {
    // Decimal feet
    if (/^\d+(\.\d+)?$/.test(value)) {
      return parseFloat(value);
    }
    // Feet + inches in one of several formats
    const match = value.match(
      /^(\d+(?:\.\d+)?)\s*(?:ft|')?\s*[- ]?\s*(\d+(?:\.\d+)?)?\s*(?:in|")?$/
    );
    if (match) {
      const feet = parseFloat(match[1]) || 0;
      const inches = parseFloat(match[2]) || 0;
      return feet + inches / 12;
    }
    return NaN;
  }

  const numeric = parseFloat(value);
  return Number.isNaN(numeric) ? NaN : numeric;
};

// Euclidean pixel distance between two {x,y} points.
export const pixelDistance = (a, b) =>
  Math.sqrt((b.x - a.x) ** 2 + (b.y - a.y) ** 2);

// Convert pixel distance to a real-world distance using a calibration factor.
export const pixelsToUnit = (pixelDist, pixelsPerUnit) =>
  pixelsPerUnit > 0 ? pixelDist / pixelsPerUnit : 0;
